import { React, useState, useEffect } from "react";
import { Button, Form, Input,  Checkbox,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm, RightDrawerContainer } from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import alertBlue from "../../../Assets/Icons/alertBlue.svg";
import { addNewGrade, getAllGradesForConfig } from "../../../Services/settingsServices";
import styled from "styled-components";
import { capital_letter } from "../../../Utils/helper/helper";

 
const ProductParam = styled.div`
.ant-checkbox-wrapper {
  display: flex;
  line-height: 30px;
}
.ant-checkbox-disabled + span {
  color: #000000D9;
 }
`;

const AddNewGrade = (props) => {

  const productParameters = [{
    label : 'GSM',
    value : 'gsm',
    disabled : true
  },
  {
    label : 'Bulk',
    value : 'bulk',
    disabled : true
  },
  {
    label : 'BF',
    value : 'burst_factor',
  },
  {
    label : 'Moisture',
    value : 'moisture',
  }];
  
  const [form] = Form.useForm();
  const [aliasList, setAliasList] = useState();
  const [nameList, setNameList] = useState();
  const [goToQualityPage, setGoToQualityPage] = useState(false);
  // const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [grade, setGrade] = useState();
  const [errorMsg, setErrorMsg] = useState("");
  const [gradeErr, setGradeErr] = useState(false);
  // const [grade, setGrade] = useState();
  const [selectedParam, setSelectedParams] = useState({
    gsm : true,
    burst_factor : false,
    moisture : false,
    bulk : true
  });

  useEffect(() => {
    if (props.visible) {
      getAllGradesForConfig()
        .then((response) => {
          // console.log("alias", response);
          setNameList(response.map((grade) => grade.name));
          setAliasList(response.map((grade) => grade.alias));
        })
        .catch((error) => console.log(error));

      return () => {
        setNameList();
        setAliasList();
      };
    }
  }, [props]);

  const onProductParameterChange = (e) => {
    let paramObject = {
    gsm : true,
    burst_factor : false,
    moisture : false,
    bulk : true
    };
    for (let index = 0; index < e.length; index++) {
      const param = e[index];
      paramObject[`${param}`] = true;
      
    }
    setSelectedParams(paramObject);
  }

  const onGradeChange = (event) => {
    setGradeErr(false);
    nameList?.forEach((grade) =>{
      if(grade?.toLowerCase () === event.target.value?.toLowerCase()){
        setGradeErr(true);
      }
    });
  }

  const onSave = (value) => {
    if (value) {
      setGoToQualityPage(true);
    }
    form.submit();
  };
  
  const onFinish = async (values) => {
    let gradeName = capital_letter((values.grade_name)?.trim());
    const reqBody = {
      // name: values.grade_name,      
      name: gradeName,
      alias: values?.grade_alias.trim()?.toUpperCase(),
      value: true,
      product: selectedParam
    };
    try {
      const saveResponse = await addNewGrade(reqBody);
      if (!saveResponse.error) {
        // setGrade(reqBody.name);
        props.addGrade({
          name: reqBody.name,
          alias: reqBody.alias,
          value: true,
        });
        form.setFieldsValue({ grade_name: "", grade_alias: "" });

        // setSuccess(true);
        // setTimeout(() => {
        //   setSuccess(false);
        // }, 3000);

        if (goToQualityPage) {
          // const fields = form.getFieldsValue();
          props.addNewGradeSuccess(reqBody.name, reqBody.alias);
        } else {
          // props.closeGradeDrawer(false);
          props.onClose(reqBody.name, reqBody.alias);
        }
        setGoToQualityPage(false);
      }
    } catch (error) {
      console.log(error);
      // setErrorMsg(error.response.data.msg);
      setError(true);
      // setTimeout(() => {
      //   setError(false);
      // }, 2000);

      if(error?.response?.status == 500){
        setErrorMsg("Something went wrong. Please try again");
      } else{
        setErrorMsg(error?.response?.data?.msg);
      }

      setTimeout(() => {
        setError(false);
        setErrorMsg("");
      }, 2000);
    }
  };

  return aliasList && nameList ? (
    <RightDrawerSidebar
      title="Add a new grade"
      subtitle=""
      visible={props.visible}
      onClose={props.onCloseGrade}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          {/* {success && <AlertContainer color="green" icon={alertGreen}
            msg={`A new grade ${grade}  is successfully added`}
          />} */}
          {/* {error &&  <AlertContainer color="red toaster" icon={alertRed} 
        msg="Error while saving grade"
        />} */}
          <AlertContainer
            color="blue"
            icon={alertBlue}
            msg="You can't modify a grade once added. A grade can only be deleted if there is no product created for that grade"
          />
          <HaberForm>
            <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin haberSignup"
              style={{ marginTop: "0" }}
              onFinish={onFinish}
            >
              <div className="drawerField">
                <div className="titleWithText">
                  <h5>Name of the grade</h5>
                  <p>The grade will be identified by this unique name</p>
                </div>
                <Form.Item
                  name="grade_name"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                    {
                      max: 50,
                      message: "Name can have a maximum of 50 characters",
                    },
                    {
                      validator(_, value) {
                        if(gradeErr){
                          return Promise.reject("Name must be unique");
                        } else{
                          return Promise.resolve();
                        }
                      },
                    },
                  ]}
                  className=""
                  initialValue=""
                >
                  <Input
                    placeholder="Enter name of the grade"
                    onChange={onGradeChange}
                    style={{ textTransform: "capitalize" }}
                  />
                </Form.Item>
              </div>

              <div className="drawerField">
                <div className="titleWithText">
                  <h5>Grade Alias</h5>
                  <p>An alternate short name to identify this grade</p>
                </div>
                <Form.Item
                  name="grade_alias"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                    {
                      max: 8,
                      message: "Alias can have a maximum of 8 characters",
                    },
                    // {
                    //   pattern: /^([A-Z])*[^\s0-9a-z]*$/,
                    //   message: "Only capital characters with no space allowed",
                    // },
                    {
                      validator(_, value) {
                        if (value == null || !aliasList.includes(value.toUpperCase())) {
                          return Promise.resolve();
                        } else {
                          return Promise.reject("Alias must be unique");
                        }
                      },
                    },
                  ]}
                  className=""
                  initialValue=""
                >
                  <Input
                    placeholder="Enter alias of the grade"
                    // style={{ textTransform: "uppercase" }}
                  style={{ textTransform: "uppercase" }}
                  />
                </Form.Item>
              </div>
              <div className="drawerField">
                <div className="titleWithText">
                  <h5>Product Parameters</h5>
                  <p>
                    The product parameters that apply to the products of this
                    grade{" "}
                  </p>
                </div>
                <Form.Item
                  name="product_parameters"
                  
                  className=""
                  initialValue=""
                >
                  <ProductParam>
                    <Checkbox.Group
                      options={productParameters}
                      defaultValue={["gsm","bulk"]}
                      // checked={isChecked}
                       onChange={onProductParameterChange}
                      className="flexRowReverse"
                    />
                  </ProductParam>
                </Form.Item>
              </div>
              <div className="buttonFlex fixedBtm">
                <Form.Item>
                  <Button
                    htmlType="submit"
                    className="themeBtn noBg"
                    // onClick={() => onSave()}
                  >
                    <Iconmoon icon="addcircle" size={16} color="#EA655B" /> Save
                    Grade{" "}
                  </Button>
                </Form.Item>
                <Form.Item>
                  <Button className="themeBtn" onClick={() => onSave(true)}>
                    <Iconmoon icon="addcircle" size={16} color="#ffffff" /> Save
                    and add quality{" "}
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </HaberForm>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  ) : (
    <></>
  );
}

export default AddNewGrade;
